import 'css-chunksrc/client/scenes/optimizedGantt/graph/elementsOverlay/element/derivation/styles.scss';export default {
  "derivation": "_derivation_1o317_1",
  "indicator": "_indicator_1o317_7"
};